import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import css from './style.css'
import DiamondShapes from '../../components/diamond-shapes'

const DiamondShapesSection = props => {
  return (
    <div>
      <Grid>
        <GridItem col='7/10' customStyle={css.gridItem}>
          <DiamondShapes />
        </GridItem>
        <GridItem col='1/10' customStyle={css.gridItem} />
        <GridItem col='2/10' customStyle={css.gridItem}>
          <div className={css.title}>
            Diamond Shapes
          </div>
          <p className={css.text}>
            Do you know what shape diamond you are looking for? If purchasing for someone else, we always recommend that if you know what shape they want then definitely get that shape. If you’re not sure, however, then stick to a round diamond. A round diamond is the most classic shape, as well as the most brilliant. Due to its perfectly symmetrical shape and cut, nothing shines quite like it.
          </p>
        </GridItem>
      </Grid>
    </div>
  )
}

export default DiamondShapesSection



// WEBPACK FOOTER //
// ./src/containers/diamond/diamond_shapes_section.js